import { init } from "@web3-onboard/react";
import injectedModule from "@web3-onboard/injected-wallets";
import walletConnectModule from "@web3-onboard/walletconnect";
import walletLinkModule from "@web3-onboard/walletlink";
import ledgerModule from '@web3-onboard/ledger'

export const SMART_CHAIN_RPC_URL = `https://speedy-nodes-nyc.moralis.io/${process.env.REACT_APP_RPC_ID}/bsc/mainnet`;

const injected = injectedModule();
const walletConnect = walletConnectModule();
const coinbase = walletLinkModule();
const ledger = ledgerModule();

export const onboard = init({
  wallets: [walletConnect, injected, coinbase, ledger],
  chains: [
    {
      id: "0x38", // chain ID must be in hexadecimel
      token: "BNB", // main chain token
      namespace: "evm",
      label: "Binance Smart Chain",
      rpcUrl: SMART_CHAIN_RPC_URL
    },
  ],
  appMetadata: {
    name: "Stackd Finance",
    icon: "images/logoNoText.svg",
    logo: "images/logo.svg",
    description: "Stackd Finance Dashboard.",
    recommendedInjectedWallets: [
      { name: "MetaMask", url: "https://metamask.io" }
    ],
  },
  i18n: {
    en: {
      connect: {
        selectingWallet:{
          sidebar: {
            heading: "Welcome",
          }
        }
      }
    }
  }
});